import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import RostersService from './RostersService';
import { isUndefined, isEmpty } from 'lodash';

// Actions
const GET_TC_EVENT_EXAMINEE_COUNT = 'rosters/GET_TC_EVENT_EXAMINEE_COUNT';
const GET_LOCATION_EVENT_EXAMINEE_COUNT = 'rosters/GET_LOCATION_EVENT_EXAMINEE_COUNT';
const GET_EVENT_EXAMINEE_COUNT = 'rosters/GET_EVENT_EXAMINEE_COUNT';
const GET_LOCATION_EVENT_ROOM_ROSTERS = 'rosters/GET_LOCATION_EVENT_ROOM_ROSTERS';
const GET_LOCATION_EVENT_EXAMINEES = 'rosters/GET_LOCATION_EVENT_EXAMINEES';
const CLEAR_LOCATION_EVENT_EXAMINEES = 'rosters/CLEAR_LOCATION_EVENT_EXAMINEES';
const GET_COMPATIBLE_ROOMS = 'rosters/GET_COMPATIBLE_ROOMS';
const ASSIGN_EXAMINEES_TO_ROOM = 'rosters/ASSIGN_EXAMINEES_TO_ROOM';
const UNASSIGN_EXAMINEES = 'rosters/UNASSIGN_EXAMINEES';
const GET_EVENT_ROSTERS_PDF = 'rosters/GET_EVENT_ROSTERS_PDF';
const GET_EVENT_ROSTERS_PDF_UUID = 'rosters/GET_EVENT_ROSTERS_PDF_UUID';
const GET_EXAMINEE_DETAILS = 'rosters/GET_EXAMINEE_DETAILS';
const GET_EXAMINEE_PHOTO = 'rosters/GET_EXAMINEE_PHOTO';
const GET_LOC_EVENT_MISMATCHED_EXAMINEES = 'rosters/GET_LOC_EVENT_MISMATCHED_EXAMINEES';
const GET_TC_EVENT_EXAM_CATEGORIES = 'rosters/GET_TC_EVENT_EXAM_CATEGORIES';
const GET_LOC_EV_RESCHEDULE_DATES = 'rosters/GET_LOC_EV_RESCHEDULE_DATES';
const GET_EV_RESCHEDULE_DATES = 'rosters/GET_EV_RESCHEDULE_DATES';

const initialState = {
  tcEventExamineeCount: [],
  locationEventExamineeCount: [],
  locationEventRoomRosters: [],
  locationEventExaminees: [],
  tcEventExamCategories: [],
  loadingExaminees: false,
  examineesTotalCount: 0,
  compatibleRooms: [],
  errorAssign: false,
  errorUnassign: false,
  loadingCompatibleRooms: false,
  currentExaminee: {},
  currentExamineePhoto: '',
  examineePhotoLoading: false,
  mismatchedExaminees: [],
  errorDownloadPDF: false,
  loadingRosterPDF: false,
  eventExamineeCount: [],
  eventExamineeCountLoading: false,
  errorDownloadUUID: false,
  loadingRoomsRosters: false,
  pdfUUID: '',
  locEvRescheduleDates: [],
  evRescheduleDates:[],
};

// Reducer
export default function rostersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TC_EVENT_EXAMINEE_COUNT:
      return {
        ...state,
        tcEventExamineeCount: action.result.data || [],
      };
    case GET_LOCATION_EVENT_EXAMINEE_COUNT:
      return {
        ...state,
        locationEventExamineeCount: action.result.data || [],
      };
    case GET_EVENT_EXAMINEE_COUNT:
      return {
        ...state,
        eventExamineeCount: action.result.data || [],
        eventExamineeCountLoading: action.result.loading,
      };
    case GET_LOCATION_EVENT_ROOM_ROSTERS:
      return {
        ...state,
        locationEventRoomRosters: action.result.data || [],
        loadingRoomsRosters: action.result.loading,
      };
    case GET_EVENT_ROSTERS_PDF:
      return {
        ...state,
        errorDownloadPDF: action.result.error,
        loadingRosterPDF: action.result.loading,
      };
    case GET_EVENT_ROSTERS_PDF_UUID:
      return {
        ...state,
        pdfUUID: action.result.data || '',
        errorDownloadUUID: !!action.result.error,
        loadingRosterPDF: action.result.loading,
      };
    case GET_LOCATION_EVENT_EXAMINEES:
      let examinees;

      if (action.result.data) {
        const { startIdx, endIdx, newLimit } = action.result.payload;
        if (state.locationEventExaminees.length && !newLimit) {
          examinees = state.locationEventExaminees.concat([]);
          if (examinees.length !== action.result.data.count) {
            examinees.length = action.result.data.count;
          }
          // if (endIdx+1 === action.result.data.count) {
          //   examinees.length = action.result.data.count;
          //   examinees.splice(startIdx, endIdx-startIdx+1, ...action.result.data.regs);
          // } else {
          //   if (state.locationEventExaminees.length === startIdx) {
          //     examinees.concat(action.result.data.regs);
          //   } else {
          //     state.locationEventExaminees.length = endIdx + 1;
          //     state.locationEventExaminees.splice(startIdx, endIdx-startIdx+1, ...action.result.data.regs);
          //   }
          // }
          examinees.splice(startIdx, endIdx-startIdx+1, ...action.result.data.regs);
        } else {
          examinees = action.result.data.regs;
        }
      }
      return {
        ...state,
        loadingExaminees: action.result.loading && !state.locationEventExaminees.length,
        examineesTotalCount: action.result.data ? action.result.data.count : state.examineesTotalCount,
        locationEventExaminees: examinees || state.locationEventExaminees,
        absentCount: action.result.data ? action.result.data.absentCount : state.absentCount,
        deniedCount: action.result.data ? action.result.data.deniedCount : state.deniedCount,
      };
    case CLEAR_LOCATION_EVENT_EXAMINEES:
      return {
        ...state,
        examineesTotalCount: 0,
        locationEventExaminees: [],
      };
    case GET_COMPATIBLE_ROOMS:
      return {
        ...state,
        compatibleRooms: action.result.data || [],
        loadingCompatibleRooms: action.result.loading,
      };
    case ASSIGN_EXAMINEES_TO_ROOM:
      return {
        ...state,
        errorAssign: !!action.result.error || (isUndefined(action.result.data) ? !action.result.data : false)  ,
      };
    case UNASSIGN_EXAMINEES:
      return {
        ...state,
        errorUnassign: !!action.result.error ,
      };
    case GET_EXAMINEE_DETAILS:
      return {
        ...state,
        currentExaminee: action.result.data || {},
      };
    case GET_EXAMINEE_PHOTO:
      return{
        ...state,
        currentExamineePhoto: action.result.data || '',
        examineePhotoLoading: action.result.loading,
      };
    case GET_TC_EVENT_EXAM_CATEGORIES:
      return {
        ...state,
        tcEventExamCategories: action.result.data || [],
      };
    case GET_LOC_EV_RESCHEDULE_DATES:
      return {
        ...state,
        locEvRescheduleDates: action.result.data || [],
      };
    case GET_EV_RESCHEDULE_DATES:
      return {
        ...state,
        evRescheduleDates: action.result.data || [],
      };
    default:
      return state;
  }
}

// Action Creators
export function getTcEventExamineeCountAction(result) {
  return { type: GET_TC_EVENT_EXAMINEE_COUNT, result };
}

export function getLocationEventExamineeCountAction(result) {
  return { type: GET_LOCATION_EVENT_EXAMINEE_COUNT, result };
}

export function getEventExamineeCountAction(result) {
  return { type: GET_EVENT_EXAMINEE_COUNT, result };
}

export function getLocationEventRoomRostersAction(result) {
  return { type: GET_LOCATION_EVENT_ROOM_ROSTERS, result };
}

export function getLocationEventExamineesAction(result) {
  return { type: GET_LOCATION_EVENT_EXAMINEES, result };
}

export function getCompatibleRoomsAction(result) {
  return { type: GET_COMPATIBLE_ROOMS, result };
}

export function clearLocationEventExamineesAction() {
  return { type: CLEAR_LOCATION_EVENT_EXAMINEES, result: {} };
}

export function unassignExamineesAction(result) {
  return { type: UNASSIGN_EXAMINEES, result };
}

export function assignExamineesToRoomAction(result) {
  return { type: ASSIGN_EXAMINEES_TO_ROOM, result };
}

export function getEventRostersPdfAction(result) {
  return { type: GET_EVENT_ROSTERS_PDF, result };
}

export function getEventRostersPdfUUIDAction(result) {
  return { type: GET_EVENT_ROSTERS_PDF_UUID, result };
}

export function getExamineeDetailsAction(result) {
  return { type: GET_EXAMINEE_DETAILS, result };
}

export function getExamineePhotoAction(result) {
  return { type: GET_EXAMINEE_PHOTO, result };
}

export function getTcEventExamCategoriesAction(result) {
  return { type: GET_TC_EVENT_EXAM_CATEGORIES, result };
}

export function getLocEvRescheduleDatesAction(result) {
  return { type: GET_LOC_EV_RESCHEDULE_DATES, result };
}

export function getEvRescheduleDatesAction(result) {
  return { type: GET_EV_RESCHEDULE_DATES, result };
}

// Action dispatcher functions

export function getTcEventExamineeCount(eventId) {
  return createDispatchFunction(
    partial(RostersService.getTcEventExamineeCount, eventId),
    getTcEventExamineeCountAction
  );
}

export function getLocationEventExamineeCount(locationEventId) {
  return createDispatchFunction(
    partial(RostersService.getLocationEventExamineeCount, locationEventId),
    getLocationEventExamineeCountAction
  );
}

export function getEventExamineeCount(locations) {
  return createDispatchFunction(
    partial(RostersService.getEventExamineeCount, locations),
    getEventExamineeCountAction
  );
}

export function getLocationEventRoomRosters(locationEventId) {
  return createDispatchFunction(
    partial(RostersService.getLocationEventRoomRosters, locationEventId),
    getLocationEventRoomRostersAction
  );
}

export function getLocationEventExaminees(locationEventId, params, payload) {
  return createDispatchFunction(
    partial(RostersService.getLocationEventExaminees, locationEventId, params),
    getLocationEventExamineesAction, payload
  );
}

export function getExamineeDetails(examineeId) {
  return createDispatchFunction(
    partial(RostersService.getExamineeDetails, examineeId),
    getExamineeDetailsAction
  );
}

export function getExamineePhoto(examineeId) {
  return createDispatchFunction(
    partial(RostersService.getExamineePhoto, examineeId),
    getExamineePhotoAction
  );
}

export function getCompatibleRooms(locationEventId, examineeList, params) {
  return createDispatchFunction(
    partial(RostersService.getCompatibleRooms, locationEventId, examineeList, params),
    getCompatibleRoomsAction
  );
}

export function assignExamineesToRoom(roomId, examineeList) {
  return createDispatchFunction(
    partial(RostersService.assignExamineesToRoom, roomId, examineeList),
    assignExamineesToRoomAction
  );
}

export function unassignExaminees(locationEventId, examineeList) {
  return createDispatchFunction(
    partial(RostersService.unassignExaminees, locationEventId, examineeList),
    unassignExamineesAction
  );
}

export function getEventRostersPdf(eventId, params) {
  return createDispatchFunction(
    partial(RostersService.getEventRostersPdf, eventId, params),
    getEventRostersPdfAction
  );
}

export function getEventRostersPdfUUID(eventId, params) {
  return createDispatchFunction(
    partial(RostersService.getEventRostersPdfUUID, eventId, params),
    getEventRostersPdfUUIDAction
  );
}

export function getTcEventExamCategories(tcEventId) {
  return createDispatchFunction(
    partial(RostersService.getTcEventExamCategories, tcEventId),
    getTcEventExamCategoriesAction
  );
}

export function getLocEvRescheduleDates(tcEventId, locEvId) {
  return createDispatchFunction(
    partial(RostersService.getRescheduleDates, tcEventId, {locationEventId: locEvId}),
    getLocEvRescheduleDatesAction
  );
}

export function getEvRescheduleDates(tcEventId) {
  return createDispatchFunction(
    partial(RostersService.getRescheduleDates, tcEventId),
    getEvRescheduleDatesAction
  );
}
